/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, April 29th 2022, 12:14:44 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { format } from "date-fns";

export const formatDateToISO8601 = (date: Date) => format(date, "yyyy-MM-dd");

/** Format to ISO 8601 using vanilla javascript i.e. yyyy-MM-dd */
export const nativeFormatDateToISO8601 = (date: Date) => {
  const newDateObject = new Date(date); // Making sure the function is pure.
  let month = "" + (newDateObject.getMonth() + 1);
  let day = "" + newDateObject.getDate();
  const year = newDateObject.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

// Parsing an iso 8601 date to string. Django Rest Framework returns a date field as a iso 8601 string representation
export const iso8601DateToDateString = (iso8601Date: string | Date) => {
  const parsed_date = new Date(iso8601Date);

  return isNaN(parsed_date.getDate()) ? parsed_date : parsed_date.toDateString();
};

export const convertUnixTimestampToDate = (unixTimestamp: number): Date => {
  if (!unixTimestamp) return;
  return new Date(unixTimestamp * 1000);
};
